import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Prismic from 'prismic-javascript';
import MetaTags from 'react-meta-tags';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Banners from './banners';
import Inbound from './inbound';
import Content from './content';

import LanguageContext from '../../context/LangContext';

const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
const Client = Prismic.client(apiEndpoint);

class Home extends Component {
  state = {
    banner_principal: [],
    banner_dir_topo: {},
    banner_dir_inferior: {},
    content_categories: [],
    items: [],
    items_noticias: [],
    items_videos: [],
    items_blog: [],
    seo: {},
    campanha_home: {},
  }

  componentDidMount = () => {
    window.scrollTo(0, 0)
    const { language } = this.context;
    this.setState({language: language});

    const fetchDataSeo = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'seo_home')
      )
      if (response) {
        this.setState({seo: response.results[0].data});
      }
    }
    fetchDataSeo();

    this.getContent();
  }

  componentDidUpdate() {
    const { language } = this.context;
    if (language === this.state.language)
      return false;
    this.setState({language: language});
    this.getContent();
  }
  
  getContent = () => {
    const { language } = this.context;

    const fetchDataAllContent = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'conteudo'),
        { pageSize : 3, orderings : '[my.conteudo.data desc]', lang: language}
      )
      if (response) {
        this.setState({items: response.results});
      }
    }
    fetchDataAllContent();

    const fetchDataInbound = async () => {
      const responseCampanhaHome = await Client.query(
        Prismic.Predicates.at('document.type', 'campanha_home'),
        {lang: language}
      )
      if (responseCampanhaHome.results[0]) {
        this.setState({campanha_home: responseCampanhaHome.results[0].data});
      }
    }
    fetchDataInbound();

    this.setState({"banner_principal": []})
    const fetchDataBanners = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'banner_home'),
        {lang: language}
      )
      if (response) {
        const banners = []
        response.results.map((item) => {
          switch (item.data.ordem) {
            case "Principal":
              banners.push(item.data);
              break;
            case "Topo direita":
              this.setState({"banner_dir_topo": item.data})
              break;
            case "Inferior direita":
              this.setState({"banner_dir_inferior": item.data})
              break;
            default:
          }
          return true;
        });
        banners.map((item) => item.ordem1 = item.ordem1?item.ordem1:99 )
        banners.sort((a, b) => { return a.ordem1 - b.ordem1; });
        this.setState({banner_principal: banners});
      }
    }
    fetchDataBanners();

    const fetchDataVideos = async () => {
      const responseVideos = await Client.query(
        Prismic.Predicates.at('my.conteudo.categoria', 'Xyv4BhIAACQA0T3r'),
        { pageSize : 3, orderings : '[my.conteudo.data desc]', lang: language}
      )
      if (responseVideos) {
        this.setState({items_videos: responseVideos.results});
      }
    }
    fetchDataVideos();

    const fetchDataNoticias = async () => {
      const responseNoticias = await Client.query(
        Prismic.Predicates.at('my.conteudo.categoria', 'Xyv3-BIAACEA0T2q'),
        { pageSize : 3, orderings : '[my.conteudo.data desc]', lang: language}
      )
      if (responseNoticias) {
        this.setState({items_noticias: responseNoticias.results});
      }
    }
    fetchDataNoticias();

    const fetchDataBlog = async () => {
      const responseBlog = await Client.query(
        Prismic.Predicates.at('my.conteudo.categoria', 'Xyv35xIAACMA0T1N'),
        { pageSize : 3, orderings : '[my.conteudo.data desc]', lang: language}
      )
      if (responseBlog) {
        this.setState({items_blog: responseBlog.results});
      }
    }
    fetchDataBlog();
  }

  render = () => {
    return (
      <div id="home">
        <MetaTags>
          <title>{ this.state.seo.meta_title }</title>
          <meta id="meta-description" name="description" content={ this.state.seo.meta_description } />
          <meta id="og-title" property="og:title" content={ this.state.seo.meta_title } />
        </MetaTags>
        <Header />
        <Banners 
          banner_principal={ this.state.banner_principal } 
          banner_dir_topo={ this.state.banner_dir_topo } 
          banner_dir_inferior={ this.state.banner_dir_inferior } />
        <Inbound {...this.state.campanha_home}/>
        <Content 
          items={ this.state.items } 
          items_blog={ this.state.items_blog } 
          items_videos={ this.state.items_videos } 
          items_noticias={ this.state.items_noticias } 
          categories={ this.state.content_categories } />
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

Home.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Home.contextType = LanguageContext;

export default Home;
